import { render, staticRenderFns } from "./wenli.vue?vue&type=template&id=3061fa38&"
import script from "./wenli.vue?vue&type=script&lang=ts&"
export * from "./wenli.vue?vue&type=script&lang=ts&"
import style0 from "./wenli.vue?vue&type=style&index=0&id=3061fa38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports